module.exports = __webpack_public_path__ + "prj_09.d87762bf.jpeg";